import { useClubLogo } from '../lib/useClubLogo';
import React, { useState, useEffect } from 'react';
import { publicApi, getImageUrl } from '../lib/api';



export default function GameTicker() {
  const LOGO_URL = useClubLogo();
  const [games, setGames] = useState([]);
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      try {
        const [upcoming, recent, teamsRes] = await Promise.all([
          publicApi.getUpcomingGames(3),
          publicApi.getRecentGames(3),
          publicApi.getTeams(),
        ]);
        setTeams(teamsRes.data);
        const allGames = [
          ...upcoming.data.map(g => ({ ...g, _type: 'upcoming' })),
          ...recent.data.map(g => ({ ...g, _type: 'played' })),
        ];
        setGames(allGames);
      } catch (err) { /* silent */ }
    };
    loadData();
  }, []);

  const getOpponentInfo = (game) => {
    if (game?.opponentTeamId) {
      const team = teams.find(t => t._id === game.opponentTeamId);
      if (team) return { logo: team.logoUrl ? getImageUrl(team.logoUrl) : null, short: team.shortName || game.opponent?.substring(0, 3).toUpperCase() };
    }
    return { logo: null, short: (game?.opponent || '??').substring(0, 3).toUpperCase() };
  };

  if (games.length === 0) return null;

  const tickerItems = [...games, ...games, ...games];

  return (
    <div className="bg-[hsl(0,0%,4%)] border-y border-white/5 overflow-hidden" data-testid="game-ticker">
      <div className="flex items-center">
        <div className="flex-shrink-0 bg-[#CC0000] px-3 sm:px-4 py-3 z-10 flex items-center gap-2">
          <div className="w-5 h-5 rounded-full overflow-hidden bg-[hsl(0,0%,12%)] flex-shrink-0">
            <img src={LOGO_URL} alt="" className="w-full h-full object-contain rounded-full" style={{ background: '#141414' }} />
          </div>
          <span className="text-[9px] sm:text-[10px] text-white font-bold uppercase tracking-[0.15em] whitespace-nowrap">LIVE TICKER</span>
        </div>
        <div className="overflow-hidden flex-1">
          <div className="ticker-animate flex items-center" style={{ width: 'max-content' }}>
            {tickerItems.map((game, i) => {
              const opp = getOpponentInfo(game);
              return (
                <div key={`${game._id}-${i}`} className="flex items-center gap-3 px-5 sm:px-6 py-3 border-r border-white/5">
                  {game._type === 'upcoming' ? (
                    <>
                      <span className="text-[9px] text-[#46C7FF] uppercase tracking-[0.15em] font-bold font-mono-score bg-[#46C7FF]/10 px-1.5 py-0.5 rounded">NEXT</span>
                      <div className="w-4 h-4 rounded-full overflow-hidden bg-[hsl(0,0%,12%)] flex-shrink-0">
                        <img src={LOGO_URL} alt="" className="w-full h-full object-contain rounded-full" style={{ background: '#141414' }} />
                      </div>
                      <span className="text-[11px] text-white/80 font-bold" style={{ fontFamily: 'Space Grotesk' }}>DEVILS</span>
                      <span className="text-[10px] text-white/25 font-mono-score">VS</span>
                      <div className="w-4 h-4 rounded-full overflow-hidden bg-[hsl(0,0%,12%)] flex-shrink-0 border border-white/10 flex items-center justify-center">
                        {opp.logo ? (
                          <img src={opp.logo} alt="" className="w-full h-full object-contain rounded-full" style={{ background: '#141414' }} />
                        ) : (
                          <span className="text-[6px] font-bold text-white/30">{opp.short}</span>
                        )}
                      </div>
                      <span className="text-[11px] text-white/80 font-bold" style={{ fontFamily: 'Space Grotesk' }}>{game.opponent?.toUpperCase()}</span>
                      <span className="text-[10px] text-white/25 font-mono-score">{game.date ? new Date(game.date).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' }) : ''}</span>
                    </>
                  ) : (
                    <>
                      <span className="text-[9px] text-white/30 uppercase tracking-[0.15em] font-mono-score bg-white/5 px-1.5 py-0.5 rounded">FINAL</span>
                      <div className="w-4 h-4 rounded-full overflow-hidden bg-[hsl(0,0%,12%)] flex-shrink-0">
                        <img src={LOGO_URL} alt="" className="w-full h-full object-contain rounded-full" style={{ background: '#141414' }} />
                      </div>
                      <span className="text-[11px] text-white/80 font-bold" style={{ fontFamily: 'Space Grotesk' }}>DEVILS</span>
                      <span className="text-sm font-bold text-white font-mono-score tracking-wider">{game.scoreFor ?? '-'}:{game.scoreAgainst ?? '-'}</span>
                      <div className="w-4 h-4 rounded-full overflow-hidden bg-[hsl(0,0%,12%)] flex-shrink-0 border border-white/10 flex items-center justify-center">
                        {opp.logo ? (
                          <img src={opp.logo} alt="" className="w-full h-full object-contain rounded-full" style={{ background: '#141414' }} />
                        ) : (
                          <span className="text-[6px] font-bold text-white/30">{opp.short}</span>
                        )}
                      </div>
                      <span className="text-[11px] text-white/80 font-bold" style={{ fontFamily: 'Space Grotesk' }}>{game.opponent?.toUpperCase()}</span>
                      {game.scoreFor != null && game.scoreAgainst != null && (
                        <span className={`text-[9px] font-bold px-1.5 py-0.5 rounded ${game.scoreFor > game.scoreAgainst ? 'bg-green-500/15 text-green-400' : game.scoreFor < game.scoreAgainst ? 'bg-red-500/15 text-red-400' : 'bg-yellow-500/15 text-yellow-400'}`}>
                          {game.scoreFor > game.scoreAgainst ? 'W' : game.scoreFor < game.scoreAgainst ? 'L' : 'D'}
                        </span>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
